import ajax from './_ajax';
const api = {};
api.topicGetByKey = function (key) {
  return ajax.get('/api/Topic/GetByKey?key=' + key);
};
export default api;



// WEBPACK FOOTER //
// ./src/api/topicApi.js